import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
import { GUI } from "dat.gui";
// import { GUI } from 'three-js/addons/libs/lil-gui.module.min.js';
// import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';

class Subject {
  constructor() {
    this.observers = [];
  }
  addObserver(observer) {
    this.observers.push(observer);
  }
  removeObserver(observer) {
    const index = this.observers.indexOf(observer);
    if (index > -1) {
      this.observers.splice(index, 1);
    }
  }
  animationStatus(data) {
    this.observers.forEach((observer) => observer.update(data));
  }
}

class Observer {
  constructor() {
    this.camera = THREE.PerspectiveCamera;
    this.render = this.render.bind(this);
    this.renderer = THREE.WebGLRenderer;
    this.pointLight = THREE.PointLight;
    this.geometry = THREE.IcosahedronGeometry;
    this.material = THREE.MeshLambertMaterial;
    this.geometryFrame = THREE.IcosahedronGeometry;
    this.materialFrame = THREE.MeshBasicMaterial;
    this.shape = [];
    this.scene = new THREE.Scene();

    this.reqId = 0;

    console.log(this.scene);

    this.clientDimensions = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    };

    // Camera
    this.camera = new THREE.PerspectiveCamera(
      64,
      this.clientDimensions["width"] / this.clientDimensions["height"],
      0.125,
      1000,
    );

    // Renderer
    this.renderer = new THREE.WebGLRenderer({
      alpha: false,
    });
    // Renderer -- Size
    this.renderer.setSize(
      this.clientDimensions["width"],
      this.clientDimensions["height"],
    );
    // Renderer -- Style
    this.renderer.domElement.style.position = "absolute";
    this.renderer.domElement.style.zIndex = 1;
    this.renderer.domElement.style.top = 0;

    // Append renderer to DOM
    this.appendToDOM(this.renderer.domElement);

    this.geometry = new THREE.IcosahedronGeometry(3.64, 0x0);
    this.material = new THREE.MeshLambertMaterial({
      color: 0x6fb267,
      emissive: 0x000000cc,
    });
    this.geometryFrame = new THREE.IcosahedronGeometry(8, 0);
    this.materialFrame = new THREE.MeshBasicMaterial({
      wireframe: true,
      transparent: true,
      opacity: 0.08,
      color: 0xe8e8e8,
    });
    this.shape[0] = new THREE.Mesh(this.geometryFrame, this.materialFrame);
    this.shape[0].position.set(3, 5, 1);
    this.shape[1] = new THREE.Mesh(this.geometry, this.material);
    this.shape[1].position.set(3, 5, 0.64);
    this.scene.add(this.shape[0]);
    this.scene.add(this.shape[1]);

    this.pointLight = new THREE.PointLight(0x888888);

    this.pointLight.position.set(1, 200, 128);
    this.scene.add(this.pointLight);
    this.camera.position.set(3, 5, 10); // x y z

    // this.render();

    // Expose to global scope for debugging
    globalThis.ThreeScene = {
      scene: this.scene,
      camera: this.camera,
      renderer: this.renderer,
      shape: this.shape,
      geometry: this.geometry,
      material: this.material,
      geometryFrame: this.geometryFrame,
      materialFrame: this.materialFrame,
    };

    // Start rendering loop
    // console.log('Starting render loop', this)
  }

  appendToDOM(element) {
    document.body.appendChild(element);
  }

  render() {
    this.update(true);
  }

  update(playState) {
    if (playState === true) {
      this.reqId = requestAnimationFrame(this.render);
      this.shape[0].rotation.x -= 0.008;
      this.shape[0].rotation.y -= 0.005;
      this.shape[1].rotation.x += 0.0044;
      this.shape[1].rotation.y += 0.0064;
      this.renderer.render(this.scene, this.camera);
    } else {
      cancelAnimationFrame(this.reqId);
    }
  }
}

const subject = new Subject();
const observer = new Observer();
subject.addObserver(observer);

window.addEventListener("resize", resize, false);

function resize() {
  globalThis.ThreeScene.camera.aspect =
    document.documentElement.clientWidth /
    document.documentElement.clientHeight;
  globalThis.ThreeScene.camera.updateProjectionMatrix();
  globalThis.ThreeScene.renderer.setSize(
    document.documentElement.clientWidth,
    document.documentElement.clientHeight,
  );
}

function createNavLink({
  parentId = "nav",
  href = "#",
  className = "button",
  innerHTML = "Link",
  target = null,
  id = null,
}) {
  let a_1 = document.createElement("a");
  a_1.href = href;
  a_1.className = className;
  a_1.innerHTML = innerHTML;

  if (target) {
    a_1.target = target;
  }

  if (id) {
    a_1.id = id;
  }

  if (parentId === "nav") {
    a_1.classList.add("link-bl");
    document.querySelector("#nav")?.appendChild(a_1);
  }

  if (parentId === "header") {
    a_1.classList.add("link-tl");
    document.querySelector("#header")?.appendChild(a_1);
  }
  if (parentId === "br_nav") {
    a_1.classList.add("link-br");
    document.querySelector("#br_nav")?.appendChild(a_1);
  }
  if (parentId === "tr_nav") {
    a_1.classList.add("link-tr");
    document.querySelector("#tr_nav")?.appendChild(a_1);
  }

  return a_1;
}

async function forward_paths_to_html_if_exists(link) {
  // Exit if not a link, has an extension, or is an external/anchor link
  if (
    !link ||
    link.pathname.includes(".") ||
    link.hostname !== window.location.hostname ||
    link.pathname === "/"
  ) {
    return;
  }

  const targetUrl = `${link.origin}${link.pathname}.html`;

  try {
    const response = await fetch(targetUrl, { method: "HEAD" });

    if (response.ok) {
      e.preventDefault();
      window.location.href = targetUrl;
    }
  } catch (error) {
    console.error("File check failed:", error);
  }
}

async function onDOMContentLoaded() {
  console.log("SUBJECT:OBSERVERS = ", subject.observers);
  subject.animationStatus(true);

  // setTimeout(() => {
  //   subject.animationStatus(false)
  // }, 1000)

  // setTimeout(() => {
  //   subject.animationStatus(true)
  // }, 2000)

  // HEADER NAV
  let hnav = document.createElement("div");
  hnav.id = "header";
  hnav.className = "navigaton-vertical";
  hnav.onmouseenter = () => {
    subject.animationStatus(false);
  };
  hnav.onmouseleave = () => {
    subject.animationStatus(true);
  };

  // BL NAV
  let nav = document.createElement("div");
  nav.id = "nav";
  nav.className = "navigaton-vertical";

  // BR NAV
  let br_nav = document.createElement("div");
  br_nav.id = "br_nav";
  br_nav.className = "navigaton-vertical";

  // TR NAV
  let tr_nav = document.createElement("div");
  tr_nav.id = "tr_nav";
  tr_nav.className = "navigaton-vertical";

  document.querySelector("canvas").after(nav);
  document.querySelector("canvas").after(hnav);
  document.querySelector("canvas").after(br_nav);
  document.querySelector("canvas").after(tr_nav);

  await new Promise((resolve) => setTimeout(resolve, 100));

  createNavLink({ parentId: "header", href: "#", innerHTML: ` 𝖅𝖎𝖟𝖟𝖔 ` });
  createNavLink({
    parentId: "nav",
    href: "/colorgame",
    innerHTML: ` 🌈 Puzzle `,
  });
  createNavLink({ parentId: "nav", href: "/wordle", innerHTML: ` 🔠 Wordle ` });
  createNavLink({
    parentId: "nav",
    href: "/tierlist",
    innerHTML: ` 📊 Tier List `,
  });
  createNavLink({
    parentId: "nav",
    href: "/charades",
    innerHTML: ` 🎭 Reverse Charades `,
  });
  createNavLink({
    parentId: "tr_nav",
    href: "/apps",
    innerHTML: "&nbsp; Experimental IPAs",
  });
  createNavLink({
    parentId: "tr_nav",
    href: "https://dash.cloudflare.com/1a5a2cd03952df54e6c0e5a20a789382/pages/view/zizzoorg-placeholder3d/deployments/new",
    innerHTML: "🚀 Deploy",
    id: "cfdeploy",
  });
  createNavLink({
    parentId: "br_nav",
    href: "/indexmjs",
    innerHTML: "✏️ IndexMJS Editor",
    id: "indexmjs",
  });
  createNavLink({
    parentId: "br_nav",
    href: "/icloudmanager",
    innerHTML: "☁️ iCloudManager.app",
    id: "icloudmanager",
  });
  // createNavLink({
  //   parentId: "br_nav",
  //   href: "/sleepy",
  //   innerHTML: "🌙 Sleepy.app",
  //   id: "sleepy",
  // });
  // const link_1 = document.getElementById('#icloudmanager')
  // console.log(link_1)
  // forward_paths_to_html_if_exists(link_1).then(console.log)

  // URL SEARCH PARAMS
  let search = new URLSearchParams(document.location.search);
  if (
    search.get("wallpaper") === "" ||
    Number.parseInt(search.get("wallpaper"), 10) === 1
  ) {
    console.log("hide");
    document.querySelector("#nav").style.visibility = "hidden";
  }
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
